import { MainForumTopicController } from './controllers/MainForumTopicController.js';
import { MainLastPublicationsByCategoriesController } from './controllers/MainLastPublicationsByCategoriesController.js';
import { MainCharityLotsController } from './controllers/MainCharityLotsController.js';
import { MainPublicationEventController } from './controllers/MainPublicationEventController.js';
import { MainPublicationController } from './controllers/MainPublicationController.js';
import { MainPublicationDiscussingController } from './controllers/MainPublicationDiscussingController.js';
import { BasePage } from '../../base/BasePage.js';

export class MainPage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const cp = window.appData?.cp;

        this.initResource({
            controller: new MainForumTopicController(),
            event: 'forum.getLastTopics',
            cacheKey: `forum.getLastTopics.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new MainLastPublicationsByCategoriesController(),
            event: 'publication.getLastByCategories',
            cacheKey: `publication.getLastByCategories.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new MainCharityLotsController(),
            event: 'lotTag.getAll',
            cacheKey: `lotTag.getAll.${cp}`,
            payload: {token, locale }
        });

        this.initResource({
            controller: new MainPublicationEventController(),
            event: 'publication.getLastEvent',
            cacheKey: `publication.getLastEvent.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new MainPublicationController(),
            event: 'publication.getMainEvent',
            cacheKey: `publication.getMainEvent.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new MainPublicationDiscussingController(),
            event: 'publication.getMostDiscussed',
            cacheKey: `publication.getMostDiscussed.${cp}`,
            payload: { token, locale }
        });
    }
}